export default function() {
    const body = document.getElementsByTagName('BODY')[0];
    const customvids = document.querySelectorAll('button.customplay');
    const customvidIframe = document.getElementById('videomodalIframe');
    if (customvids && customvidIframe) {
        const modalbackdrop = document.getElementById('modalbackdrop');
        const modalclose = document.getElementById('videoModalClose');

        Array.prototype.slice.call(customvids).forEach(trigger => {
            trigger.addEventListener('click', () => {
                var id = trigger.getAttribute('data-videoid');
                var src = '//www.youtube-nocookie.com/embed/' + id + '?autoplay=1&autohide=1&rel=0&showinfo=0&modestbranding=1&hd=1&wmode=transparent&enablejsapi=1&html5=1';
                customvidIframe.setAttribute('src', src);

                body.classList.add('modalopen');
                modalclose.addEventListener('click', closeModal);
                modalbackdrop.addEventListener('click', closeModal);

                function closeModal() {
                    customvidIframe.setAttribute('src', '');
                    body.classList.remove('modalopen');

                    modalbackdrop.removeEventListener('click', closeModal);
                    modalclose.removeEventListener('click', closeModal);
                }
            });
        });
    }
}
